/**
 * Les avis Google de Maison Eridia — une seule source pour tout le site.
 *
 * Pourquoi ce fichier existe. Le 30/09/2026, le même chiffre était écrit à six endroits
 * et aucun ne s'accordait : le compteur affiché disait 19, l'edge function 18 pour
 * 19 avis, et les données structurées envoyées à Google annonçaient 50 avis sur 13 pages
 * et 127 avis (note 4,9) sur 8 autres. La réalité mesurée : 20 avis, note 5,0.
 *
 * Google traite une note agrégée inventée comme du spam d'avis : perte des étoiles dans
 * les résultats, parfois une action manuelle. Et le chiffre inventé était moins bon que
 * le vrai — 4,9 annoncé contre 5,0 réel.
 *
 * Seule exception, inévitable : `supabase/functions/get-google-reviews` porte sa propre
 * copie du total. Une edge function Deno ne peut pas importer depuis `src/`, et elle se
 * déploie par le CLI quand le reste passe par Lovable. Mettre les deux à jour ensemble.
 */

/** Note moyenne de la fiche Google. */
export const AVIS_GOOGLE_NOTE = 5;

/** Nombre total d'avis sur la fiche Google, au 30/09/2026. */
export const AVIS_GOOGLE_NOMBRE = 20;

/**
 * L'objet AggregateRating de Schema.org, prêt à insérer dans un bloc JSON-LD.
 * Les valeurs sont des chaînes : c'est la forme que Google accepte partout.
 */
export const NOTE_AGREGEE_GOOGLE = {
  '@type': 'AggregateRating',
  ratingValue: String(AVIS_GOOGLE_NOTE),
  reviewCount: String(AVIS_GOOGLE_NOMBRE),
  bestRating: '5',
  worstRating: '1',
};
